import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { fetchSettings } from '../pages/admin/settings/controller/settings-controller';

// Floating WhatsApp contact button — uses the phone number ("tel") from application settings
const WhatsAppButton = () => {
  const location = useLocation();
  const [phone, setPhone] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const loadPhone = async () => {
      try {
        const settings = await fetchSettings();
        if (!cancelled && settings?.tel) {
          // Keep digits only, prefix with Tunisian country code if missing
          let digits = String(settings.tel).replace(/\D/g, '');
          if (digits && !digits.startsWith('216')) {
            digits = `216${digits}`;
          }
          if (digits.length >= 11) {
            setPhone(digits);
          }
        }
      } catch (err) {
        console.error('WhatsApp button: failed to load settings', err);
      }
    };
    loadPhone();
    return () => { cancelled = true; };
  }, []);

  // Hide on admin/login pages or when no phone configured
  const path = location.pathname;
  if (!phone || path.startsWith('/admin') || path.startsWith('/login')) {
    return null;
  }

  const message = encodeURIComponent('Bonjour, j\'ai une question concernant vos produits.');

  return (
    <a
      href={`https://wa.me/${phone}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactez-nous sur WhatsApp"
      className="fixed z-50 bottom-24 md:bottom-6 right-4 md:right-6 group"
    >
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" style={{ animationDuration: '2s' }} />

      <span className="relative flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] shadow-lg shadow-green-500/30 transition-transform duration-300 group-hover:scale-110">
        {/* WhatsApp icon */}
        <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white" aria-hidden="true">
          <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.59 4.47 1.71 6.41L3.2 28.8l6.57-1.67a12.74 12.74 0 0 0 6.23 1.62h.01c7.06 0 12.79-5.74 12.79-12.8 0-3.42-1.33-6.63-3.75-9.05a12.72 12.72 0 0 0-9.04-3.7zm0 23.39h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-4.02 1.02 1.07-3.92-.25-.4a10.55 10.55 0 0 1-1.63-5.66c0-5.87 4.78-10.65 10.66-10.65 2.85 0 5.52 1.11 7.53 3.12a10.59 10.59 0 0 1 3.12 7.54c0 5.87-4.78 10.66-10.68 10.66zm5.85-7.98c-.32-.16-1.9-.94-2.19-1.04-.29-.11-.51-.16-.72.16-.21.32-.83 1.04-1.01 1.25-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.22-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.12 1.09-1.12 2.66s1.15 3.09 1.31 3.3c.16.21 2.26 3.44 5.47 4.83.76.33 1.36.53 1.83.68.77.24 1.47.21 2.02.13.62-.09 1.9-.78 2.17-1.53.27-.75.27-1.39.19-1.53-.08-.13-.29-.21-.61-.37z" />
        </svg>
      </span>
    </a>
  );
};

export default WhatsAppButton;
